<template>
  <div class="oa-datepicker">
    <datepicker
      calendar-class="datetime-picker"
      format="dd/MM/yyyy"
      placeholder="Pick a date..."
      v-bind:value="value"
      v-on:selected="datePicked"
      :disabledDates="disabledDates"
      :calendar-button="true"
      :calendar-button-icon="`calendar-svg`"
    />
  </div>
</template>

<script>

import Datepicker from 'vuejs-datepicker';

export default {
  name: 'OaDatepicker',
  components: {
    Datepicker,
  },
  props: {
    value: { required: true },
    disabledDates: {
      default: () => ({}),
    },
  },
  methods: {
    datePicked(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
